const dskSmallestCardRenditionKey = 'rendition_desktop_size1000'; // [496x279]
const dskSmallCardRenditionKey = 'rendition_desktop_size1000'; // [752x423]
const dskMediumCardRenditionKey = 'rendition_desktop_size1000'; // [1008x574]
const dskLargeCardRenditionKey = 'rendition_desktop_size1500'; // [1520x855]
const mblSmallestCardRenditionKey = 'rendition_mobile_size200'; // [122x68]
const mblSmallCardRenditionKey = 'rendition_mobile_size200'; // [185x104]
const mblMediumCardRenditionKey = 'rendition_mobile_size300'; // [249x140]
const mblLargeCardRenditionKey = 'rendition_mobile_size500'; // [375x210]

function imgRenditions(dskRenditionKey, mblRenditionKey) {
  return {
    dskRenditionKey,
    mblRenditionKey,
  };
}

export type TImageRenditionsByPosition = {
  [key: number]: {
    [key: number]: {
      dskRenditionKey:
        | typeof dskSmallestCardRenditionKey
        | typeof dskSmallCardRenditionKey
        | typeof dskMediumCardRenditionKey
        | typeof dskLargeCardRenditionKey;
      mblRenditionKey:
        | typeof mblSmallestCardRenditionKey
        | typeof mblSmallCardRenditionKey
        | typeof mblMediumCardRenditionKey
        | typeof mblLargeCardRenditionKey;
    };
  };
};

export const imageRenditionsByPosition: TImageRenditionsByPosition = {
  '12': {
    1: imgRenditions(dskSmallestCardRenditionKey, mblSmallestCardRenditionKey),
    2: imgRenditions(dskSmallestCardRenditionKey, mblSmallestCardRenditionKey),
    3: imgRenditions(dskMediumCardRenditionKey, mblMediumCardRenditionKey),
    4: imgRenditions(dskLargeCardRenditionKey, mblLargeCardRenditionKey),
    5: imgRenditions(dskSmallestCardRenditionKey, mblSmallestCardRenditionKey),
    6: imgRenditions(dskSmallestCardRenditionKey, mblSmallestCardRenditionKey),
    7: imgRenditions(dskSmallestCardRenditionKey, mblSmallestCardRenditionKey),
    8: imgRenditions(dskSmallCardRenditionKey, mblSmallCardRenditionKey),
    9: imgRenditions(dskSmallCardRenditionKey, mblSmallCardRenditionKey),
    10: imgRenditions(dskMediumCardRenditionKey, mblMediumCardRenditionKey),
    11: imgRenditions(dskSmallestCardRenditionKey, mblSmallestCardRenditionKey),
    12: imgRenditions(dskSmallestCardRenditionKey, mblSmallestCardRenditionKey),
  },
  '11': {
    1: imgRenditions(dskSmallestCardRenditionKey, mblSmallestCardRenditionKey),
    2: imgRenditions(dskSmallestCardRenditionKey, mblSmallestCardRenditionKey),
    3: imgRenditions(dskMediumCardRenditionKey, mblMediumCardRenditionKey),
    4: imgRenditions(dskLargeCardRenditionKey, mblLargeCardRenditionKey),
    5: imgRenditions(dskSmallestCardRenditionKey, mblSmallestCardRenditionKey),
    6: imgRenditions(dskSmallestCardRenditionKey, mblSmallestCardRenditionKey),
    7: imgRenditions(dskSmallestCardRenditionKey, mblSmallestCardRenditionKey),
    8: imgRenditions(dskLargeCardRenditionKey, mblLargeCardRenditionKey),
    9: imgRenditions(dskMediumCardRenditionKey, mblMediumCardRenditionKey),
    10: imgRenditions(dskSmallestCardRenditionKey, mblSmallestCardRenditionKey),
    11: imgRenditions(dskSmallestCardRenditionKey, mblSmallestCardRenditionKey),
  },
  '10': {
    1: imgRenditions(dskSmallestCardRenditionKey, mblSmallestCardRenditionKey),
    2: imgRenditions(dskSmallestCardRenditionKey, mblSmallestCardRenditionKey),
    3: imgRenditions(dskMediumCardRenditionKey, mblMediumCardRenditionKey),
    4: imgRenditions(dskLargeCardRenditionKey, mblLargeCardRenditionKey),
    5: imgRenditions(dskSmallestCardRenditionKey, mblSmallestCardRenditionKey),
    6: imgRenditions(dskSmallestCardRenditionKey, mblSmallestCardRenditionKey),
    7: imgRenditions(dskSmallestCardRenditionKey, mblSmallestCardRenditionKey),
    8: imgRenditions(dskMediumCardRenditionKey, mblMediumCardRenditionKey),
    9: imgRenditions(dskSmallestCardRenditionKey, mblSmallestCardRenditionKey),
    10: imgRenditions(dskSmallestCardRenditionKey, mblSmallestCardRenditionKey),
  },
  '9': {
    1: imgRenditions(dskSmallestCardRenditionKey, mblSmallestCardRenditionKey),
    2: imgRenditions(dskSmallestCardRenditionKey, mblSmallestCardRenditionKey),
    3: imgRenditions(dskMediumCardRenditionKey, mblMediumCardRenditionKey),
    4: imgRenditions(dskLargeCardRenditionKey, mblLargeCardRenditionKey),
    5: imgRenditions(dskSmallestCardRenditionKey, mblSmallestCardRenditionKey),
    6: imgRenditions(dskSmallestCardRenditionKey, mblSmallestCardRenditionKey),
    7: imgRenditions(dskSmallestCardRenditionKey, mblSmallestCardRenditionKey),
    8: imgRenditions(dskSmallCardRenditionKey, mblSmallCardRenditionKey),
    9: imgRenditions(dskSmallCardRenditionKey, mblSmallCardRenditionKey),
  },
  '8': {
    1: imgRenditions(dskSmallestCardRenditionKey, mblSmallestCardRenditionKey),
    2: imgRenditions(dskSmallestCardRenditionKey, mblSmallestCardRenditionKey),
    3: imgRenditions(dskMediumCardRenditionKey, mblMediumCardRenditionKey),
    4: imgRenditions(dskSmallCardRenditionKey, mblSmallCardRenditionKey),
    5: imgRenditions(dskSmallCardRenditionKey, mblSmallCardRenditionKey),
    6: imgRenditions(dskLargeCardRenditionKey, mblLargeCardRenditionKey),
    7: imgRenditions(dskSmallCardRenditionKey, mblSmallCardRenditionKey),
    8: imgRenditions(dskSmallCardRenditionKey, mblSmallCardRenditionKey),
  },
  '7': {
    1: imgRenditions(dskSmallestCardRenditionKey, mblSmallestCardRenditionKey),
    2: imgRenditions(dskSmallestCardRenditionKey, mblSmallestCardRenditionKey),
    3: imgRenditions(dskMediumCardRenditionKey, mblMediumCardRenditionKey),
    4: imgRenditions(dskLargeCardRenditionKey, mblLargeCardRenditionKey),
    5: imgRenditions(dskSmallestCardRenditionKey, mblSmallestCardRenditionKey),
    6: imgRenditions(dskSmallestCardRenditionKey, mblSmallestCardRenditionKey),
    7: imgRenditions(dskSmallestCardRenditionKey, mblSmallestCardRenditionKey),
  },
  '6': {
    1: imgRenditions(dskSmallestCardRenditionKey, mblSmallestCardRenditionKey),
    2: imgRenditions(dskSmallestCardRenditionKey, mblSmallestCardRenditionKey),
    3: imgRenditions(dskMediumCardRenditionKey, mblMediumCardRenditionKey),
    4: imgRenditions(dskSmallestCardRenditionKey, mblSmallestCardRenditionKey),
    5: imgRenditions(dskSmallestCardRenditionKey, mblSmallestCardRenditionKey),
    6: imgRenditions(dskSmallestCardRenditionKey, mblSmallestCardRenditionKey),
  },
  '5': {
    1: imgRenditions(dskSmallestCardRenditionKey, mblSmallestCardRenditionKey),
    2: imgRenditions(dskSmallestCardRenditionKey, mblSmallestCardRenditionKey),
    3: imgRenditions(dskMediumCardRenditionKey, mblMediumCardRenditionKey),
    4: imgRenditions(dskSmallCardRenditionKey, mblSmallCardRenditionKey),
    5: imgRenditions(dskSmallCardRenditionKey, mblSmallCardRenditionKey),
  },
  '4': {
    1: imgRenditions(dskSmallestCardRenditionKey, mblSmallestCardRenditionKey),
    2: imgRenditions(dskSmallestCardRenditionKey, mblSmallestCardRenditionKey),
    3: imgRenditions(dskMediumCardRenditionKey, mblMediumCardRenditionKey),
    4: imgRenditions(dskLargeCardRenditionKey, mblLargeCardRenditionKey),
  },
  '3': {
    1: imgRenditions(dskSmallestCardRenditionKey, mblSmallestCardRenditionKey),
    2: imgRenditions(dskSmallestCardRenditionKey, mblSmallestCardRenditionKey),
    3: imgRenditions(dskMediumCardRenditionKey, mblMediumCardRenditionKey),
  },
  '2': {
    1: imgRenditions(dskSmallCardRenditionKey, mblSmallCardRenditionKey),
    2: imgRenditions(dskSmallCardRenditionKey, mblSmallCardRenditionKey),
  },
  '1': {
    1: imgRenditions(dskLargeCardRenditionKey, mblLargeCardRenditionKey),
  },
};
